<template>
  <div class="row">
    <div class="col-12 col-md-4">
      <div class="form-group">
        <label for="level">¿En qué nivel educativo esta tu hija/o?</label>
        <select
          @change="handleChangeSelect"
          class="form-control"
          name="level"
          id="level"
          v-model="level"
        >
          <option v-for="item in levels" :key="item.value" :value="item.value">{{item.label}}</option>
        </select>
      </div>
    </div>
    <div class="col-12 col-md-3" v-if="currentGrades">
      <div class="form-group">
        <label for="grade">¿En qué grado escolar?</label>
        <select
          @change="handleChangeSelect"
          class="form-control"
          name="grade"
          id="grade"
          v-model="grade"
        >
          <option v-for="item in currentGrades" :key="item.value" :value="item.value">{{item.label}}</option>
        </select>
      </div>
    </div>
    <div class="col-12 col-md-3">
      <div class="form-group">
        <label for="area">¿Qué área quieres desarrollar?</label>
        <select
          @change="handleChangeSelect"
          class="form-control"
          name="area"
          id="area"
          v-model="area"
        >
          <option v-for="item in areas" :key="item.value" :value="item.value">{{item.label}}</option>
        </select>
      </div>
    </div>
    <div class="col-12 col-md-2">
      <div class="form-group">
        <label for="type">Tipo:</label>
        <select
          @change="handleChangeSelect"
          class="form-control"
          name="type"
          id="type"
          v-model="type"
        >
          <option v-for="item in types" :key="item.value" :value="item.value">{{item.label}}</option>
        </select>
      </div>
    </div>
    <div class="col-12 col-md-3 d-flex d-flex align-items-center justify-content-center">
      <button
        @click="handleChangeAnnexes"
        class="anexos btn mt-2 mt-lg-0"
        v-if="!currentGrades"
      >Anexos para niños/as de 0 a 2 años</button>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      siteUrl: window.ui_school_data.site_url,
      apiPath: 'wp-json/resources/v1',
      currentGrades: false,
      levels: [
        { value: 'all', label: 'Mostrar todos' },
        { value: 'preescolar', label: 'Preescolar' },
        { value: 'primaria', label: 'Primaria' },
        { value: 'secundaria', label: 'Secundaria' },
      ],
      basicGrades: [
        { value: 'primero', label: '1ro' },
        { value: 'segundo', label: '2do' },
        { value: 'tercero', label: '3ro' },
        { value: 'cuarto', label: '4to' },
        { value: 'quinto', label: '5to' },
        { value: 'sexto', label: '6to' },
      ],
      hightGrades: [
        { value: 'primero', label: '1ro' },
        { value: 'segundo', label: '2do' },
        { value: 'tercero', label: '3ro' },
      ],
      areas: [
        { value: 'all', label: 'Mostrar todos' },
        { value: 'lengua', label: 'Lengua Materna Español' },
        { value: 'pensamiento', label: 'Pensamiento Matemático' },
        { value: 'desarrollo', label: 'Desarrollo Socio-Emocional' },
      ],
      types: [],
      level: 'all',
      grade: null,
      area: 'all',
      type: null,
    };
  },
  mounted() {
    this.getTypes();
  },
  methods: {
    getTypes() {
      this.isLoading = true;
      const apiUrl = `${this.siteUrl}/${this.apiPath}/types`;
      axios
        .post(apiUrl)
        .then((response) => {
          if (response.status === 200) {
            this.types = response.data;
            this.type = response.data[0].value;
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log('error :', error);
          this.isLoading = false;
        });
    },
    handleChangeSelect(event) {
      const el = event.currentTarget;
      if (el.getAttribute('id') === 'level') {
        if (this.level === 'primaria') {
          this.currentGrades = this.basicGrades;
          this.grade = 'primero';
        }
        if (this.level === 'secundaria') {
          this.currentGrades = this.hightGrades;
          this.grade = 'primero';
        }
        if (this.level === 'preescolar' || this.level === 'all') {
          this.currentGrades = null;
          this.grade = null;
        }
      }
      this.$emit('change', {
        level: this.level,
        grade: this.grade,
        area: this.area,
        type: this.type,
      });
    },
    handleChangeAnnexes() {
      this.$emit('filters', {
        source: 'anexos',
      });
    },
  },
};
</script>

<style scoped>
.anexos {
  background-color: #eafaf6;
  font-size: 14px;
  padding: 15px;
}
.col,
.col-1,
.col-2,
.col-3,
.col-4,
.col-5,
.col-6,
.col-7,
.col-8,
.col-9,
.col-10,
.col-11,
.col-12,
.col-auto,
.col-lg,
.col-lg-1,
.col-lg-2,
.col-lg-3,
.col-lg-4,
.col-lg-5,
.col-lg-6,
.col-lg-7,
.col-lg-8,
.col-lg-9,
.col-lg-10,
.col-lg-11,
.col-lg-12,
.col-lg-auto,
.col-md,
.col-md-1,
.col-md-2,
.col-md-3,
.col-md-4,
.col-md-5,
.col-md-6,
.col-md-7,
.col-md-8,
.col-md-9,
.col-md-10,
.col-md-11,
.col-md-12,
.col-md-auto,
.col-sm,
.col-sm-1,
.col-sm-2,
.col-sm-3,
.col-sm-4,
.col-sm-5,
.col-sm-6,
.col-sm-7,
.col-sm-8,
.col-sm-9,
.col-sm-10,
.col-sm-11,
.col-sm-12,
.col-sm-auto,
.col-xl,
.col-xl-1,
.col-xl-2,
.col-xl-3,
.col-xl-4,
.col-xl-5,
.col-xl-6,
.col-xl-7,
.col-xl-8,
.col-xl-9,
.col-xl-10,
.col-xl-11,
.col-xl-12,
.col-xl-auto {
  position: relative !important;
  width: 100% !important;
  min-height: 1px !important;
  padding-right: 15px !important;
  padding-left: 15px !important;
}
</style>
